import React from 'react';
import "./ProfilePicture.scss";

export default function ProfilePicture(props) {	
	return (
		<div className="profile-image">
			{props.user ? props.user.substring(0,1) : ""}
		</div>
	);
}